<template>
  <div>
    <dl>
      <dt v-if="!isGift && itemCard.headImg">
        <img :src="itemCard.headImg" v-http2 v-img-size="'mini'" />
      </dt>
      <dd class="dd-title" :class="isGift ? 'dd-title-left' : ''">
        <p :class="nameClass" class="name">
          <span v-if="isGift">{{ $t('礼物') }}</span
          >{{ itemCard.itemName }}
        </p>
        <p class="desc">{{ itemCard.subItemDesc }}</p>
        <p class="special" v-if="isSpecial">
          <Limittxt v-if="specialText" :content="specialText" />
        </p>
        <p class="price">
          {{ itemCard.specialPriceDisplay }}
          <s v-if="itemCard.specialPrice !== itemCard.price">{{
            itemCard.priceDisplay
          }}</s>
        </p>
      </dd>
    </dl>
  </div>
</template>

<script>
import Limittxt from '@/components/CateResult/limittxt';
import { get } from 'lodash-es';
import { CATE_ACT_TYPE_CONFIG } from '@/const/dishfood';

export default {
  data() {
    return {};
  },
  props: {
    itemCard: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Limittxt,
  },
  computed: {
    isGift() {
      return (
        this.itemCard &&
        Number(this.itemCard?.mduType) === CATE_ACT_TYPE_CONFIG.BUY_GIFT.type
      );
    },
    isSpecial() {
      return (
        Number(this.itemCard.activityType) === CATE_ACT_TYPE_CONFIG.SPECIAL.type
      );
    },
    nameClass() {
      if (this.isGift) {
        return 'name-gift';
      } else if (!this.isGift && !this.itemCard?.headImg) {
        return 'name-max';
      }
      return '';
    },
    specialText() {
      return get(this.itemCard, 'actTag[0].content', '');
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
dl {
  display: flex;
  min-width: 232px;
  dt {
    margin-right: 12px;
    img {
      width: 62px;
      height: 62px;
      border-radius: 4px;
      object-fit: cover;
      text-align: center;
      border: 1px solid #e5e5e5;
    }
  }
  .dd-title {
    flex: 1;
    .name {
      font-family: 'Aspira Medium';
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      width: 156px;
      @include text-overflow();
      span {
        background: linear-gradient(90deg, #fff2e7 0%, #ffeadf 100%);
        border-radius: 2px;
        @include font-color();
        font-family: 'PingFangSC Medium';
        font-size: 11px;
        padding: 0 4px;
        position: relative;
        top: -2px;
        display: inline-block;
        margin-right: 10px;
      }
    }
    .name-max {
      width: 232px;
    }
    .name-gift {
      width: 200px;
    }
    .desc {
      font-family: 'Aspira Light';
      font-weight: 200;
      font-size: 14px;
      line-height: 16px;
      margin: 6px 0 8px 0;
    }
    .price {
      font-family: 'Aspira Light';
      font-weight: 200;
      font-size: 16px;
      margin-right: 2px;
      s {
        font-size: 12px;
        color: #999999;
        position: relative;
        top: -1px;
      }
    }
    .special {
      font-family: 'Aspira Light';
      font-weight: 200;
      margin: 8px 0;
      font-size: 14px;
      color: #ff7a45;
    }
  }
  .dd-title-left {
    margin-left: 32px;
    min-width: 180px;
    .name {
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 768px) {
  dl {
    min-width: rem(448);
    dt {
      margin-right: rem(24);
      img {
        width: rem(120);
        height: rem(120);
        border-radius: rem(8);
      }
    }
    .dd-title {
      flex: 1;
      .name {
        font-size: rem(36);
        line-height: rem(40);
        width: rem(296);
        span {
          border-radius: rem(4);
          font-size: rem(22);
          padding: 0 rem(12);
          margin-right: rem(20);
          top: rem(-4);
        }
      }
      .name-max {
        width: rem(448);
      }
      .name-gift {
        font-size: rem(28);
        width: rem(384);
      }
      .desc {
        font-family: 'Aspira Thin';
        font-size: rem(28);
        line-height: rem(32);
        margin: rem(12) 0;
      }
      .price {
        font-size: rem(32);
        s {
          font-size: rem(24);
        }
      }
      .special {
        margin: rem(16) 0;
        font-size: rem(28);
      }
    }
    .dd-title-left {
      margin-left: rem(48);
      min-width: rem(360);
    }
  }
}
</style>